import * as React from "react";
import { SelectTrigger } from "ui/select";
import { cn } from "./utils";

const SelectTriggerUI = React.forwardRef<
  React.ElementRef<typeof SelectTrigger>,
  React.ComponentPropsWithoutRef<typeof SelectTrigger>
>(({ className, ...props }, ref) => {
  return (
    <SelectTrigger
      ref={ref}
      className={cn(
        "border-none bg-transparent shadow-none",
        "!h-[23px] !min-h-0",
        "!px-0 !py-0",
        "text-sm leading-none",
        "flex items-center justify-between",
        "[&>span]:p-0 [&>span]:m-0 [&>span]:leading-none",
        "[&_[data-slot=select-value]]:p-0",
        "focus:ring-0 focus:outline-none",
        "data-[state=open]:ring-0",
        className,
      )}
      {...props}
    />
  );
});

SelectTriggerUI.displayName = "SelectTriggerSmall";

export { SelectTriggerUI };
